import { UserIdentity } from "~/api/Api";
import { Icon } from "~/assets/icons/Icon";

import styles from "./GoogleAccountHandle.module.scss";
import { formatIdentityName } from "./utils/formatIdentityName";

export const GoogleAccountHandle = ({
  identity,
  variant,
}: {
  identity: UserIdentity;
  variant: "short" | "full";
}) => {
  return (
    <p className={styles.root}>
      <Icon
        iconName="GoogleIcon"
        width="1rem"
        height="1rem"
        className={styles.icon}
      />{" "}
      {formatIdentityName(identity, variant)}
    </p>
  );
};
